"use strict";
exports.login = () => '/login';
exports.register = () => '/register';
exports.logout = () => '/logout';
exports.forgotPassword = () => '/forgot-password';
exports.task = (taskId) => `/tasks/${taskId}`;
exports.tasks = () => `/`;
exports.newTask = () => '/tasks/new';
exports.runningTask = (taskId) => `/tasks/${taskId}/running`;



/** WEBPACK FOOTER **
 ** ./src/utils/routes.ts
 **/